import { clusterColorScheme } from "../constants/colors";

export const getLineColor = (index) => {
    const schemeIndex = index % clusterColorScheme.length;
    return clusterColorScheme[schemeIndex]?.major || "#8884d8";
};